import type { HookLogDto } from "../../types/hookLog";

function toInt(raw: unknown): number | null {
  if (raw == null || raw === "") return null;
  const parsed = Number(raw);
  return Number.isFinite(parsed) ? Math.trunc(parsed) : null;
}

function pickString(raw: unknown): string | null {
  if (typeof raw !== "string") return null;
  const trimmed = raw.trim();
  return trimmed.length > 0 ? trimmed : null;
}

function pickBool(raw: unknown): boolean {
  return raw === true || raw === 1 || raw === "1" || raw === "true";
}

function normalizeRequestHeaders(raw: unknown): Record<string, string> | null {
  if (!raw || typeof raw !== "object" || Array.isArray(raw)) return null;

  const out: Record<string, string> = {};
  for (const [key, value] of Object.entries(raw as Record<string, unknown>)) {
    if (typeof value === "string") out[key] = value;
  }

  return Object.keys(out).length > 0 ? out : null;
}

export function normalizeHookLog(raw: unknown): HookLogDto | null {
  if (!raw || typeof raw !== "object") return null;

  const item = raw as Record<string, unknown>;
  const id = toInt(item.id);
  const formId = toInt(item.formId ?? item.form_id);
  const submissionId = toInt(item.submissionId ?? item.submission_id);
  const url = pickString(item.url);
  const method = pickString(item.method);

  if (id == null || formId == null || submissionId == null || !url || !method) {
    return null;
  }

  const createdAt = pickString(item.createdAt ?? item.created_at) ?? "";

  return {
    id,
    formId,
    submissionId,
    deliveryId: pickString(item.deliveryId ?? item.delivery_id),
    attempt: toInt(item.attempt) ?? 1,
    url,
    method,
    format: pickString(item.format),
    requestHeaders: normalizeRequestHeaders(
      item.requestHeaders ?? item.request_headers,
    ),
    requestBody: pickString(item.requestBody ?? item.request_body),
    responseStatus: toInt(item.responseStatus ?? item.response_status),
    responseBody: pickString(item.responseBody ?? item.response_body),
    success: pickBool(item.success),
    errorMessage: pickString(item.errorMessage ?? item.error_message),
    durationMs: toInt(item.durationMs ?? item.duration_ms),
    createdAt,
  };
}

export function normalizeHookLogsList(raw: unknown): HookLogDto[] {
  if (Array.isArray(raw)) {
    return raw
      .map(normalizeHookLog)
      .filter((item): item is HookLogDto => item != null);
  }

  if (raw && typeof raw === "object") {
    const data = (raw as { data?: unknown }).data;
    return normalizeHookLogsList(data);
  }

  return [];
}
